import React from "react";
import { ApolloProvider, ApolloClient, InMemoryCache } from "@apollo/client";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./App.css";
import NavBar from "./NavBar";
import Home from "./Home";
import Footer from "./Footer";
import SocialIcons from "./SocialIcons";
import { BrowserRouter as Router, Routes, Route} from "react-router-dom";
import DetailsPage from "./DetailsPage";
import ScrollToTop from "./ScrollToTop";
import TermsAndConditions from "./TermsAndConditions";
import ServicesDetails from "./ServicesDetails";
import CeoSpeaks from "./CeoSpeaks";
import SimTarrif from "./SimTarrif";
import RechargePolicy from "./RechargePolicy";
import Offers from "./Offers";
import Discounts from "./Discounts"


const client = new ApolloClient({
  uri: "https://www.rennamobile.com/api/graphql",
  cache: new InMemoryCache(),
  headers: {
    Authorization:
      "Bearer da46976e14bf029fbf386db62383a0ccf25facccbc8510fe358753518bdc31318b80a1bc81ab40b2eeccfc0f59de96e4ca0af9f8683146fc252e257875b7709f3d337a4b376208807266712d8da2e6affbf21267f481d74d2d82a92337f6d47f342d5a15844153d7d8350dea72df3281377e03c36974d4c4c127b7a5412ca762",
  },
});

function App() {

  return (
    <ApolloProvider client={client}>
      <Router>
        <ScrollToTop />
        <div className="app-grid">
          <header>
            <NavBar />
          </header>
          <main>
            <SocialIcons />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="sim-tariff" element={<SimTarrif />} />
              <Route path="promotions/details" element={<DetailsPage />} />
              <Route path="services/details" element={<ServicesDetails />} />
              <Route
                path="/terms-and-conditions"
                element={<TermsAndConditions />}
              />
              <Route path="/ceo-speaks" element={<CeoSpeaks />} />
              <Route path="/online-recharge-policy" element={<RechargePolicy />} />
              <Route path="/offers" element={<Offers />} />
              <Route path="/more-discounts" element={<Discounts />} />

			  <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <footer>
            <Footer />
          </footer>
        </div>
      </Router>
    </ApolloProvider>
  );
}

export default App;
